<div class="container not-found">
  <div class="row">
    <div class="col text-center">
      <h1>Pagina non Trovata</h1>
      <br>
      <div class="alert alert-info">
        Ci dispiace, ma la pagina che stai cercando non esiste.
      </div>
      <a *ngIf="!this.isLanding" class="btn btn--brand-color-03" href="javascript:void(0)" (click)="goToHomeRoute()">Torna alla Home</a>
    </div>
  </div>
</div>
